<template>
    <div :style="'border-radius: 10px; horiz-align: center; padding-left: 16px; border:2px solid black; padding-bottom: 15px; padding-right: 16px; padding-top: 2px'">
        <b-row :id="`row-${ element._id }`" :style="`background-color: ${element.type === 'CORE' ? 'green' : 'orange'};
         border-radius: 10px 10px 0 0; padding-left: 5px; padding-right: 5px;`">
            <b-col cols="4">
                <div style="padding-left: 5px; padding-right: 10px">
                    <font-awesome-icon class="handle" :icon="['fas', 'bars']" size="2x"/>
                </div>
            </b-col>
            <b-col cols="6">
            </b-col>
            <b-col cols="2" class="text-right">
                <div style="float: right; padding-top: 5px; padding-right: 5px; vertical-align: top;">
                    <font-awesome-icon icon="minus-circle" size="2x"
                                       @click="deleteQuestion(element._id, theSection, element.type, thePageName, element.name)"/>
                    <font-awesome-icon icon="pencil-alt" size="2x"
                                       @click="editQuestion(element._id, section)"/>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="1">
            </b-col>
            <b-col cols="10">
                <div>
                    <b-row style="margin: 5px 0 0 0">
                        <b-col cols="2">Title:</b-col>
                        <b-col cols="4">
                            <b-form-input :id="`question-name${ element._id }`" v-model="element.name"
                                          :disabled=true></b-form-input>
                        </b-col>
                        <b-col cols="3">
                            <label>Measure Category:</label>
                        </b-col>
                        <b-col cols="3">
                            <b-form-select id="question-category" v-model="element.type"
                                           :options="questionRequireOptions" :disabled=true></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row style="margin: 5px 0 0 0">
                        <b-col cols="2">
                            <label :for="`question-type${ element._id }`">Measure Type:</label>
                        </b-col>
                        <b-col cols="4">
                            <b-form-select :id="`question-type${ element._id }`" v-model="element.controlType"
                                           :options="questionTypeOptions" :disabled=true></b-form-select>
                        </b-col>
                        <b-col cols="4"><label :for="`question-qnum${element._id}`">Question Number</label></b-col>
                        <b-col cols="2">
                            <b-form-input :id="`question-qnum${ element._id }`" v-model="element.qnum" :disabled=true>
                                {{ element.qnum }}
                            </b-form-input>
                        </b-col>
                    </b-row>
                    <b-row style="margin: 0 0 5px 0" v-if="isCheckbox(element.controlType)">
                        <b-col cols="2">
                            <label :for="`choices${ element._id }`">Checkable Options:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-row style="margin: 0 0 5px 10px" v-for="option in element.choices"
                                   v-model="element.choices">
                                <b-form-input :id="`choices-name${ element._id }`" :value="option"
                                              :disabled=true></b-form-input>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row style="margin: 0 0 5px 0">
                        <b-col cols="2">
                            <label :for="`question-text${ element._id }`">Question Text:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-textarea :id="`question-text${ element._id }`" v-model="element.title"
                                             :disabled=true>
                            </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row style="margin: 0 0 5px 0">
                        <b-col cols="2">
                            <label :for="`green-note${ element._id }`">Green Note:</label>
                        </b-col>
                        <b-col cols="10">
                            <b-form-textarea rows="2" max-rows="3" :id="`green-note${ element._id }`"
                                             v-model="element.greenNote"
                                             :disabled=true>
                            </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row style="margin: 0 0 5px 0">

                    </b-row>
                </div>
            </b-col>
            <b-col cols="1">
            </b-col>
        </b-row>
        <b-modal :id="`modal-${element._id}`" class="modal" v-model="showModal" :ref="`modal-${element._id}`" size="xl"
                 :title="`Question Editor-${measure._id}`" effect="fade/zoom" @close="cancel(element._id)">
            <b-row>
                <b-col cols="1">
                </b-col>
                <b-col cols="10">
                    <div>
                        <b-row>
                            <b-col cols="2">Title:</b-col>
                            <b-col cols="4">
                                <b-form-input :id="`question-name${ measure._id }`" v-model="measure.name"
                                              :disabled=true></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="2">
                                <label>Measure Category:</label>
                            </b-col>
                            <b-col cols="10">
                                <b-form-select id="question-category" v-model="measure.type"
                                               :options="questionRequireOptions" :disabled=true></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="2">
                                <label :for="`question-type${ measure._id }`">Measure Type:</label>
                            </b-col>
                            <b-col cols="10">
                                <b-form-select :id="`question-type${ measure._id }`" v-model="measure.controlType"
                                               :options="questionTypeOptions" :disabled=true></b-form-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="2">
                                <label :for="`question-text${ measure._id }`">Question Text:</label>
                            </b-col>
                            <b-col cols="10">
                                <b-form-textarea rows="3" max-rows="6" :id="`question-text${ measure._id }`"
                                                 v-model="measure.title">
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="2">
                                <label :for="`question-text${ measure._id }`">Green Note:</label>
                            </b-col>
                            <b-col cols="10">
                                <b-form-textarea rows="3" max-rows="6" :id="`question-text${ measure._id }`"
                                                 v-model="measure.greenNote">
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row style="margin: 5px 0 0 0" v-if="isCheckbox(measure.controlType)">
                            <b-col cols="2">
                                <label :for="`choices${ measure._id }`">Checkable Options:</label>
                            </b-col>
                            <b-col cols="2">
                                <font-awesome-icon icon="plus-circle" size="1x"
                                                   @click="addOption(measure._id)"/>
                                Add Option
                            </b-col>
                            <b-col cols="8">
                                <b-row style="margin: 5px 0 0 0; vertical-align: center"
                                       v-for="(option) in theChoices"
                                       :key="option.id">
                                    <b-form-input style="width: 90%; margin-right: 2px"
                                                  v-model="option.value"
                                                  :key="option.id"
                                                  :disabled=false></b-form-input>
                                    <font-awesome-icon style="line-height: inherit; margin-left: 2px; margin-top: 3px"
                                                       icon="minus-circle" size="1x"
                                                       @click="deleteOption(option)"/>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row style="margin-top: 5px">
                            <b-col cols="2"><label :for="`question-qnum${measure._id}`">Question Number</label></b-col>
                            <b-col cols="10">
                                <b-form-input :id="`question-qnum${ measure._id }`" v-model="measure.qnum"
                                              :disabled=true>{{ measure.qnum }}
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col cols="1">
                </b-col>
            </b-row>
            <div slot="modal-footer" class="modal-footer">
                <button type="submit" class="btn btn-success" @click="close('close',element._id)">Save</button>
                <button type="button" class="btn btn-default" @click="cancel(element._id)">Cancel</button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Bus from "../eventBus";

export default {
  name: 'DraggableQuestion',
  components: {},
  props: {
    element: {},
    section: {},
    pageName: {}
  },
  data() {
    return {
      questionRequireOptions: [
                    {value: "CORE", text: "CORE"},
                    {value: "ELECTIVE", text: "ELECTIVE"}
                ],
                questionTypeOptions: [
                    {value: "CHECKBOX", text: "CHECKBOX"},
                    {value: "COMMENT", text: "COMMENT"},
                    {value: "MATRIX", text: "MATRIX"},
                    {value: "TEXT", text: "TEXT"}
                ],
                modalOpen: false,
                showModal: false,
                measureUpdate: {},
                measure: this.element,
                thePageName: this.pageName,
                theSection: this.section,
                theChoices: []
            }
        },
        created() {
            Bus.$on('survey-edited', this.checklistUpdate);
        },
        beforeDestroy() {
            Bus.$off('survey-edited', this.checklistUpdate);
        },
        mounted() {
            this.measure.choices.forEach((value, i) => {
                this.theChoices.push({id: i, value: value});
            })
        },
        methods: {
            isCheckbox: function (controlTypeName) {
                return controlTypeName === 'CHECKBOX';
            },
            checklistUpdate(positionMap) {
                let newPosition = positionMap[this.element._id];
                if (newPosition) {
                    this.element.qNum = newPosition;
                }
            },
            addOption: function (id) {
                this.theChoices.push({id: this.theChoices.length, value: 'New Option'});
            },
            deleteOption: function (option) {
                let index = this.measure.choices.indexOf(option);
                this.measure.choices.splice(index, 1);
            },
            deleteQuestion: function (id, section, type, pageName, measureName) {
                Bus.$emit("delete-measure", id, type, pageName, measureName);
            },
            editQuestion: function (id) {
                let action = "EDIT";
                this.actionQuestion(action, id);
            },
            actionQuestion: function (action, id) {
                this.$bvModal.show(`modal-${id}`);
            },
            close: function (action, id) {
                this.$bvModal.hide(`modal-${id}`);
                let self = this;
                this.theChoices.forEach(val => {
                    let theIndex = self.theChoices.indexOf(val);
                    if (theIndex <= (self.measure.choices.length - 1)) {
                        this.$set(self.measure.choices, theIndex, val.value);
                    } else {
                        self.measure.choices.push(val.value);
                    }
                });
                Bus.$emit("edit-measure", this.measure);
            },
            cancel: function (id) {
                this.$bvModal.hide(`modal-${id}`);
            }
        }
    }
</script>
<style>
    .handle {
        cursor: move
    }
</style>
